<template>
	<div>
		<div class="headView">
			<div class="headView_top">
				<p class="applyTitle">项目名称：{{basicParams.project_name}}</p>
				<div class="headView_top_btn" v-if="allSubmit">
					<!-- showScore  -->
					<button type="button" @click="upShow('tips')">确认提交</button>
					<div class="btnTips">
						<img src="../../assets/img/login/注释.png" style="width: 18px;height: 18px;">
						<p>一旦提交，不可修改，请谨慎操作</p>
					</div>
				</div>
			</div>
			<div class="headClass">
				<p>项目类型：{{basicParams.project_type_name}}</p>
				<p>申请时间：{{basicParams.apply_start}}-{{basicParams.apply_end}}</p>
				<p>审核时间：{{basicParams.app_start}}-{{basicParams.app_end}}</p>
			</div>
		</div>
		<!-- 申报审核通用封装组件 -->
		<div class="content_view">
			<div class="contentLeft">
				<p v-for="(item,index) in navList" v-if="item" :key="index" @click="changeTab(index)"
				   :class="navIndex === index?'tabActive':''" >
					{{item}}
				</p>
			</div>
			<div class="contentRight">

				<div v-show="navIndex === 0">

					<p class="view_head">申报通知</p>
					<!-- pdf -->
					<div style="height: 650px;overflow-y: scroll">
						<pdfVue v-if="require_pdf_url" :pdf_url="require_pdf_url"></pdfVue>
					</div>


					<div style="margin-bottom: 5px;text-align: center;margin-top: 5px">
						<el-button :type="primary" @click="doReady" :disabled="disabled">{{btnContent}}</el-button>
					</div>

				</div>

				<div v-show="navIndex === 1">
					<p class="view_head">评选标准</p>
					<!-- pdf -->
					<div style="height: 650px;overflow-y: scroll">
						<pdfVue v-if="selection_pdf_url" :pdf_url="selection_pdf_url"></pdfVue>

					</div>

					<div style="margin-bottom: 5px;text-align: center;margin-top: 5px">
						<el-button :type="primary" @click="doReady2" :disabled="disabled">{{btnContent}}</el-button>
					</div>

				</div>

				<div v-show="navIndex === 2">
					<p class="view_head">
						基本信息
					</p>
					<!-- 质量管理小组 -->
					<qualityTeam v-if="projectType === '6'" :basicMsg="basicMsg" @basicInfo="getBasicInfo">
					</qualityTeam>
					<!-- 先进企业 -->
					<advanceEnter v-if="projectType === '3'" :basicMsg="basicMsg" @basicInfo="getBasicInfo">
					</advanceEnter>
					<!-- 优秀安装工程5 -->
					<div class="inputList" v-if="projectType === '5'">
						<labelInput :outInput="basicMsg.company_name" :spanRequired="true" normalPlace="请输入单位名称"
									@inputChange="labelInput($event,'company_name')" spanTitle="单位名称" :spanWidth="spanWidth"
									componentWidth="520px">
						</labelInput>
						<div class="" style="width: 520px;">
						</div>
						<p class="view_head midflex">申报联系人</p>
						<labelInput :outInput="basicMsg.contact_name" :spanRequired="true" normalPlace="请输入申报联系人"
									@inputChange="labelInput($event,'contact_name')" spanTitle="申报联系人" :spanWidth="spanWidth"
									componentWidth="520px">
						</labelInput>
						<labelInput :outInput="basicMsg.dep" :spanRequired="true" normalPlace="请输入所在部门"
									@inputChange="labelInput($event,'dep')" spanTitle="所在部门" :spanWidth="spanWidth"
									componentWidth="520px">
						</labelInput>
						<labelInput :outInput="basicMsg.cellphone" :spanRequired="true" normalPlace="请输入手机号码"
									@inputChange="labelInput($event,'cellphone')" :isPhone="true" specilType='number'
									:maxLimit="11" spanTitle="手机号码" :spanWidth="spanWidth" componentWidth="520px">
						</labelInput>
						<labelInput :outInput="basicMsg.phone" normalPlace="请输入固定电话"
									@inputChange="labelInput($event,'phone')" spanTitle="固定电话" :spanWidth="spanWidth"
									componentWidth="520px">
						</labelInput>

						<p class="view_head midflex">申报工程概况</p>
						<labelInput :outInput="basicMsg.project_name" :spanRequired="true" normalPlace="请输入工程名称"
									@inputChange="labelInput($event,'project_name')" spanTitle="工程名称" :spanWidth="spanWidth"
									componentWidth="520px">
						</labelInput>
						<labelInput :outInput="basicMsg.declared_project" :spanRequired="true" normalPlace="请输入申报工程内容"
									@inputChange="labelInput($event,'declared_project')" spanTitle="申报工程内容"
									:spanWidth="spanWidth" componentWidth="520px">
						</labelInput>
						<labelInput :outInput="basicMsg.construc_enp" :spanRequired="true" normalPlace="请输入建设单位"
									@inputChange="labelInput($event,'construc_enp')" spanTitle="建设单位" :spanWidth="spanWidth"
									componentWidth="520px">
						</labelInput>
						<labelInput :outInput="basicMsg.use_enp" :spanRequired="true" normalPlace="请输入使用单位"
									@inputChange="labelInput($event,'use_enp')" spanTitle="使用单位" :spanWidth="spanWidth"
									componentWidth="520px">
						</labelInput>
						<labelInput :outInput="basicMsg.design_enp" :spanRequired="true" normalPlace="请输入设计单位"
									@inputChange="labelInput($event,'design_enp')" spanTitle="设计单位" :spanWidth="spanWidth"
									componentWidth="520px">
						</labelInput>
						<labelInput :outInput="basicMsg.supervise_enp" :spanRequired="true" normalPlace="请输入监理单位"
									@inputChange="labelInput($event,'supervise_enp')" spanTitle="监理单位" :spanWidth="spanWidth"
									componentWidth="520px">
						</labelInput>

						<p class="view_head midflex">参建单位</p>

						<div style="display: flex;align-items: center;justify-content: flex-start;width: 100%;flex-wrap: wrap;"
							 v-for="(items,indexs) in oldAddList">
							<labelText spanTitle="参建单位" :spanWidth="spanWidth" componentWidth="520px"
									   :pContent="items.type"></labelText>
							<div style="display: flex;align-items: center;">
								<labelText spanTitle="单位名称" :spanWidth="spanWidth" componentWidth="500px"
										   :pContent="items.name"></labelText>
								<el-button style="width: 70px;height: 40px;margin-left: 10px;"
										   @click="deleteList(indexs,'1')">删
								</el-button>
							</div>
						</div>

						<!-- 新增模块 下拉 -->
						<div style="display: flex;align-items: center;flex-wrap: wrap;" v-for="(item,index) in addList"
							 :key="index">
							<normalSelect style="margin-right: 30px;" :outInput="item.type" :spanRequired="true"
										  pelaceHolder='请选择参建方式' @selectCode="typeThreeInput($event,'1',index)"
										  :spanWidth="spanWidth" :dataList="installList" componentWidth="500px" spanTitle="参建单位">
							</normalSelect>
							<div style="display: flex;align-items: center;">
								<labelInput :outInput="item.name" :spanRequired="true" normalPlace="请输入单位名称"
											@inputChange="typeThreeInput($event,'2',index)" spanTitle="单位名称" spanWidth="180px"
											componentWidth="500px">
								</labelInput>
								<el-button style="width: 70px;height: 40px;margin-left: 10px;"
										   @click="deleteList(index)">删
								</el-button>
							</div>
						</div>
						<!-- 按钮 -->
						<div class="newAddBtn">
							<el-button type="primary" @click="addInstall">增行</el-button>
						</div>
					</div>

					<!-- 优秀项目成果2 -->
					<goodResults v-if="projectType === '2'" :basicMsg="basicMsg" @basicInfo="getBasicInfo">
					</goodResults>
					<!-- 优秀项目经理0 -->
					<goodManager v-if="projectType === '0'" :basicMsg="basicMsg" @req_num_code="getreq_num_code"
								 @basicInfo="getBasicInfo">
					</goodManager>
					<!-- 优秀建造师1 -->
					<goodConstructor v-if="projectType === '1'" :basicMsg="basicMsg" @req_num_code="getreq_num_code"
									 @basicInfo="getBasicInfo"></goodConstructor>
					<!-- BIM申报 === '7' -->
					<BIM v-if="projectType === '7'" :basicMsg="basicMsg" @basicInfo="getBasicInfo"
						 @moreSelect="moreSelect"></BIM>
				</div>

				<div v-show="navIndex == 3">
					<p class="view_head" v-show="projectType !== '0'">获奖信息</p>
					<p class="view_head" v-show="projectType === '0'">个人简历</p>
					<!-- 质量小组 -->
					<qualityTeam v-if="projectType === '6'" :awardMsg="awardMsg" :isBasic="false"
								 @awardInfo="getAwardInfo"></qualityTeam>
					<!-- 先进企业 -->
					<advanceEnter v-if="projectType === '3'" :awardMsg="awardMsg" :isBasic="false"
								  @awardInfo="getAwardInfo"></advanceEnter>
					<!-- 优秀建造师 -->
					<goodConstructor v-if="projectType === '1'" :awardMsg="awardMsg" :isBasic="false"
									 @awardInfo="getAwardInfo">
					</goodConstructor>
					<!-- 优秀项目经理 -->
					<div class=""  v-show="projectType === '0'">

						<div style="float: left;margin-bottom: 5px">1、从事施工项目管理工作简历（时间、工程名称、任何职务）（1500字以内）</div>
						<el-input
								type="textarea"
								placeholder="请输入内容"
								v-model="textarea"
								:rows="10"
								maxlength="1500"
						></el-input>


						<div style="float: left;margin-bottom: 5px;margin-top: 5px">2、优秀事迹（1500字以内）</div>
						<el-input
								type="textarea"
								placeholder="请输入内容"
								v-model="textarea2"
								:rows="10"
								maxlength="1500"
						></el-input>

					</div>
					<!-- <goodManager :isBasic="false" v-if="projectType === '0'" :awardMsg="awardMsg"
						@awardInfo="getAwardInfo">
					</goodManager> -->
				</div>


				<div class="uploadContent" v-show="navIndex === 4">
					<div v-show="projectType === '0'">
						<goodManager :isBasic="false" v-if="projectType === '0'" :awardMsg="awardMsg"
									 @awardInfo="getAwardInfo">
						</goodManager>
					</div>

					<div v-show="projectType !== '0'">
					<!--	<div class="uploadHead" @click="upShow('muban')">
							<img src="../../assets/img/main/muban.png" style="width: 20px;height: 20px;">
							<p>模板下载</p>
						</div>-->
						<p class="view_head">资料上传</p>
						<div class="uploadList" v-for="(item,index) in uploadData.title" :key="index">
							<div class="uploadList_head">
								<p>{{item}}</p>
								<div class="head_list">
									<img v-if="index === 0" src="../../assets/img/main/download.png"
										 style="width: 20px;height: 20px;">

									<p v-if="index === 0" @click="downLoadFile" style="margin-right: 20px;">点击生成</p>

									<p v-if="index === 1 && projectType==2" @click="upShow('muban')" style="margin-right: 20px;">
										<img src="../../assets/img/main/download.png" style="width: 20px;height: 20px;">模板下载
									</p>

									<p v-if="index === 2 && projectType==3" @click="upShow('muban')" style="margin-right: 20px;">
										<img src="../../assets/img/main/download.png" style="width: 20px;height: 20px;">模板下载
									</p>


									<img src="../../assets/img/main/upload.png" style="width: 20px;height: 20px;">
									<p @click="upShow('upload',index)">点击上传</p>
								</div>
							</div>
							<div class="uploadList_mid">
								<p>{{uploadData.tips[index]}}</p>
							</div>
							<div class="uploadList_bot">
								<div class="inner_upload" v-for="(item,key) in uploadList[index]" :key="key"
									 @click="showPriv(item)">
									<p>{{item.name?item.name:item.data_name}}</p>
									<img src="../../assets/img/login/cuowu.png" @click.stop="deleteUpload(key,index)">
								</div>
							</div>
						</div>
					</div>

				</div>

				<div v-show="navIndex === 5">
					<div class="uploadHead" @click="upShow('muban')">

						<p>模板下载</p>
					</div>
					<p class="view_head">资料上传</p>
					<div class="uploadList" v-for="(item,index) in uploadData.title" :key="index">
						<div class="uploadList_head">
							<p>{{item}}</p>
							<div class="head_list">
								<img v-if="index === 1" src="../../assets/img/main/download.png"
									 style="width: 20px;height: 20px;">
								<p v-if="index === 1" @click="downLoadFile" style="margin-right: 20px;">点击生成</p>
								<img src="../../assets/img/main/upload.png" style="width: 20px;height: 20px;">
								<p @click="upShow('upload',index)">点击上传</p>
							</div>
						</div>
						<div class="uploadList_mid">
							<p>{{uploadData.tips[index]}}</p>
						</div>
						<div class="uploadList_bot">
							<div class="inner_upload" v-for="(item,key) in uploadList[index]" :key="key"
								 @click="showPriv(item)">
								<p>{{item.name?item.name:item.data_name}}</p>
								<img src="../../assets/img/login/cuowu.png" @click.stop="deleteUpload(key,index)">
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>

		<div class="uploadBtn" v-show="navIndex == 2">
			<el-button type="primary" @click="basicInfo">保存</el-button>
		</div>

		<div class="uploadBtn" v-show="navIndex == 3">
			<el-button v-if="projectType !=='0'" type="primary" @click="getWinninginfo">保存</el-button>
			<el-button v-if="projectType ==='0'" type="primary" @click="personInfo">保存</el-button>
		</div>
		<div class="uploadBtn" v-show="navIndex == 4" >
			<div v-show="projectType ==='0'">
				<el-button  type="primary" @click="getWinninginfo">保存</el-button>
			</div>
			<div v-show="projectType !=='0'" style="display: flex;flex-flow: column;">
				<div class="content_btn">
					<p>资料上传后请点击保存</p>
				</div>
				<el-button type="primary" @click="setUploadFile">保存</el-button>
			</div>

		</div>

		<div class="uploadBtn" v-show="navIndex == 5" style="display: flex;flex-flow: column;">
			<div class="content_btn">
				<p>资料上传后请点击保存</p>
			</div>
			<el-button type="primary" @click="setUploadFile">保存</el-button>
		</div>

		<!-- 弹窗 -->
		<addDialog ref="download" @submitSuccess="submitSuccess"></addDialog>
	</div>
</template>

<script>
	// getUploadFile上传文件附件
	import {
		getManagerInfo,
		getProjectDetail,
		getWinningInfo,
		sureSubmit,
		getApplyDetail,
		getUploadFile,
		getDataItem,
		getBasicA,
		setBasicProgram,
		setTeamBasicInfo,
		setAdvanceInfo,
		setBIMBasicInfo,
		setPersonInfo
	} from '../../api/moudles/manager.js'
	import {
		API_DOMAIN
	} from '../../api/api.js'
	import {
		vaildte
	} from '../../utils/validate.js'
	import pdfVue from './components/pdfVue.vue'
	import labelText from '../../components/table/labelText.vue'
	import labelInput from '../../components/table/labelInput.vue'
	import normalPicker from '../../components/table/normalPicker.vue'
	import normalSelect from '../../components/table/normalSelect.vue'
	import addDialog from './components/addDialog.vue'
	// 质量管理小组
	import qualityTeam from './components/qualityTeam.vue'
	// 先进企业
	import advanceEnter from './components/advancedEnterprise.vue'
	// 优秀项目经理
	import goodManager from './components/goodManager.vue'
	// 优秀建造师
	import goodConstructor from './components/goodConstructor.vue'
	// 优秀项目成果
	import goodResults from './components/goodResults.vue'
	// BIM
	import BIM from './components/BIM.vue'

	export default {
		data() {
			return {
				makeShow:0,
				basicMsg: {},
				awardMsg: [],
				// 质量小组基本信息
				basicInfo_6: {},
				check: false,
				disabled: false,
				// 参建单位
				textarea:'',
				textarea2:'',
				oldAddList: [],
				addList: [
					// 	{
					// 	type: '',
					// 	name: '',
					// },
				],
				// 参建方式
				installList: [
					[{
						name: '建设单位',
						code: '建设单位'
					}, {
						name: '设计单位',
						code: '设计单位'
					}, {
						name: '监理单位',
						code: '监理单位'
					}, {
						name: '其他施工单位',
						code: '其他施工单位'
					}]
				],
				projectType: '',
				basicParams: {},
				navIndex: 0,
				newnavIndex: 0,
				primary:'primary',
				spanWidth: '180px',
				navList: [
					"申报通知",
					"评选标准",
					"基本信息",
					"获奖信息",
					"资料上传"
				],
				// 基本信息的
				req_num_code: '',
				project_code: '',
				// 基本信息表单
				levelOne: {},
				// 优质安装工程
				levelThree: {
					company_name: '',
					contact_name: '',
					dep: '',
					cellphone: '',
					phone: '',
					project_name: '',
					declared_project: '',
					construc_enp: '',
					use_enp: '',
					design_enp: '',
					supervise_enp: '',
				},
				// 基本信息表单
				formName: {
					real_name: '姓名',
					id_card: '身份证',
					birth_date: '出生年月',
					// project_code: '',
					education: '学历',
					join_work_time: '参加工作时间',
					title: '职称',
					major: '建造师专业',
					level: '建造师等级',
					req_num: '注册编号',
					cellphone: '本人联系电话',
					head_dep: '单位主管部门',
					enp_contact: '单位联系人',
					enp_contact_phone: '联系电话',
					// continue_year: '最近一次教育年度',
					// 优秀建造师
					present_post: '职务',
					project_name: '项目名称',
					company_name: '单位名称',
					contacts: '联系人',
					contacts_phone: '联系人电话',
					achievement_name: '成果标题',
					headcount: '编制人数',
					engineering: '项目部名称',
					author: '编制人姓名',
					// 优质安装工程
					// company_name:'单位名称',
					contact_name: '联系人',
					dep: '所在部门',
					// cellphone:'手机号',
					// phone: '固定电话',
					// project_name:'工程名称',
					declared_project: '申报工程内容',
					construc_enp: '建设单位',
					use_enp: '使用单位',
					design_enp: '设计单位',
					supervise_enp: '监理单位',
					// participating_units:'',
					// 质量小组
					declaration_unit: '申报单位',
					unit_address: '单位地址',
					group_name: '小组名称',
					topic_name: '课题名称',
					course_type: '课程类型',
					contacts_name: '单位联系人',
					contacts_cellphone: '联系人手机',
					publisher: '发布人姓名',
					publisher_phone: '发布人手机号',
					post: '获奖工程所从事职务',
					tellphone: '本人联系电话',
					introduction: '小组简介',
					// 先进企业
					// company_name:'',
					// contacts:'',
					// contacts_phone:'',
					output_value: '总产值',
					contract_amount: '合同额',
					liability_ratio: '资产负债率',
					profit_rate: '产值利润率',
					growth_rate: '净资产增长率',
					// BIM
					declarant_name: '申报人姓名',
					declarant_post: '申报人职位',
					declarant_phone: '申报人电话',
					achievement_name: '成果名称',
					achievement_group: '成果分组',
					contacts_name: '联系人姓名',
					contacts_phone: '联系人电话',
					contacts_address: '联系地址',
					declarant_units: '申报单位',
					leading_member: '团队成员',
				},
				// 获奖信息
				project_app_num: '',
				award_msg: ['质量获奖情况', '安全文明情况'],
				levelTwo: {
					awardJson: [{}, {}, ]
				},
				// 申报通知
				require_pdf_url: '',
				// 评选标准
				selection_pdf_url: '',
				btnContent:'我已阅读',
				totalTime:15,
				canClick: true, //添加canClick
				// 模板下载列表
				modelList: [],
				// 上传文件列表
				clickIndex: 0,
				uploadList: [],
				// 最终提交
				allSubmit: false,
				// 资料上传内容
				uploadData: '',
				// BIM申报的三个申报单位
				listArray: []
			}
		},
		components: {
			labelInput,
			labelText,
			addDialog,
			pdfVue,
			normalPicker,
			normalSelect,
			qualityTeam,
			advanceEnter,
			goodManager,
			goodConstructor,
			goodResults,
			BIM
		},
		created() {
			this.countDown()
			if (!this.$route.params.projectCode) {
				this.$router.go(-1)
				return
			}
			// 获取pdf
			this.getProjectdetail(this.$route.params.projectCode)
			// 模板下载列表
			this.modelList = JSON.parse(this.$route.params.distribution_materials)
			// 获取项目类型字段
			const projectType = this.$route.params.type
			console.log('projectType', projectType)
			this.projectType = projectType

			// 对申报类型进行区分
			if (projectType === '1') {
				// 优秀建造师
				this.levelTwo.awardJson = [{}, {}, {}, {}]
				this.award_msg = ['质量获奖情况', '安全文明情况、科技示范情况', '省级地方、行业标准', '科技奖、科技成果鉴定']
			} else if (projectType === '0') {
				//	优秀项目经理
				this.navList = ['申报通知', '评选标准', '基本信息', '个人简历', '获奖信息','资料上传']
			} else if (projectType === '2') {
				// 优秀项目成果
				this.navList[3] = ''
				// 文件上传第二个限制pdf上传

			} else if (projectType === '5') {
				// 优质安装工程
				this.navList[3] = ''
				this.levelOne = this.levelThree
				this.formName['company_name'] = '单位名称'
				this.formName['cellphone'] = '手机号'
				this.formName['project_name'] = '工程名称'
			} else if (projectType === '6') {
				// 质量管理小组

			} else if (projectType === '3') {
				// 先进企业
				this.formName['company_name'] = '单位 名称'
				this.levelTwo.awardJson = [{}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, {}, ]
				this.award_msg = ['质量获奖情况', '质量获奖情况', '质量获奖情况', '安全文明情况', '安全文明情况', '安全文明情况', '科技奖、科技成功鉴定、科技示范区',
					'科技奖、科技成功鉴定、科技示范区', '科技奖、科技成功鉴定、科技示范区', '信用建设奖', '信用建设奖', '信用建设奖'
				]
			} else if (projectType === '7') {
				// BIM申报
				this.navList[3] = ''
			}

			// 绑定project_code
			this.levelOne.project_code = this.$route.params.projectCode
			this.project_code = this.$route.params.projectCode
			getDataItem({
				data: {
					type: projectType
				},
				success: res => {
					// console.log(res)
					this.uploadData = res.data
				}
			})
		},
		methods: {
			async personInfo(){
				await setPersonInfo({
					data:{
						content:this.textarea,
						personal_resume2:this.textarea2,
						project_app_num:this.project_app_num
					},
					success:res=>{

						console.log('res',res)

						if (res.code === 200) {

							this.$message({
								type: 'success',
								message: '保存成功!'
							});

						} else {
							this.$message.error(res.msg)
						}


					}
				})
			},
			countDown() {
				if (!this.canClick) return  //改动的是这两行代码
				this.canClick = false
				this.btnContent =   '我已阅读' + '('+this.totalTime+'s)'

				this.disabled  = true

				let clock = window.setInterval(() => {
					this.totalTime--
					this.btnContent = '我已阅读' + '('+this.totalTime+'s)'
					if (this.totalTime < 0) {
						window.clearInterval(clock)
						this.btnContent = '我已阅读'
						this.disabled  = false
						this.totalTime = 15
						this.canClick = true  //这里重新开启
					}
				},1000)
			},

			doReady(){
				this.makeShow++
				this.navIndex++

				this.countDown()

			},

			doReady2(){
				this.makeShow++
				this.navIndex++
			},

			// 下载pdf模板
			downLoadFile() {
				if (!this.project_app_num) {
					this.$message.error('请先提交基本信息')
					return
				}
				const url =
						`${API_DOMAIN}/proapi/down/download-basic-msg?type=${this.projectType}&project_app_num=${this.project_app_num}&project_name=${this.basicParams.project_name}`
				window.open(url)
			},
			moreSelect(e) {
				this.listArray = e
			},
			// 优秀项目经理
			// 获取注册编号
			getreq_num_code(e) {
				this.req_num_code = e
			},
			// 获取质量小组获奖信息
			getAwardInfo(e) {
				const [id, name, value] = e
				if (value === '' || value === null) {
					delete this.levelTwo.awardJson[id][name]
				} else {
					this.levelTwo.awardJson[id][name] = value
				}
			},
			// 获取质量小组基本信息
			getBasicInfo(e) {
				this.levelOne = {
					...e
				}
				this.levelOne.project_code = this.project_code
			},
			// 保存的图片删除
			deleteUpload(key, index) {
				this.$confirm('此操作将删除该文件, 是否继续?', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					this.uploadList[index].splice(key, 1)
					this.$message({
						type: 'success',
						message: '删除成功!'
					});
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			// 新增参建单位输入
			typeThreeInput(e, type, index) {
				if (type == '1') {
					this.addList[index].type = e
				} else {
					this.addList[index].name = e
				}
			},
			// 删除所在行
			// deleteList(index) {
			// 	if (this.addList.length === 1) {
			// 		this.$message.error(`至少填写一条参建信息`)
			// 		return
			// 	}
			// 	this.addList.splice(index, 1)
			// },
			// 删除行
			deleteList(index, type) {
				const number = this.addList.length + this.oldAddList.length
				if (number === 1) {
					this.$message.error(`至少填写一条参建信息`)
					return
				}
				if (type === '1') {
					// 例旧信息
					this.oldAddList.splice(index, 1)
				} else {
					this.addList.splice(index, 1)
				}

			},
			// 新增参建单位
			addInstall() {
				this.addList.push({})
			},
			// 预览
			showPriv(e) {
				window.open(e.url);
			},
			// 上传文件附件保存
			async setUploadFile() {
				let newArray = this.uploadList.filter(function(s) {
					return s && s.length
				});
				if (!this.project_app_num) {
					this.$message.error('请先提交基本信息')
					return
				}
				if (!newArray.length) {
					this.$message.error('请先上传文件')
					return
				}
				if (newArray.length < 2) {
					this.$message.error('至少上传两条')
					return
				}
				if(newArray.length < 10 && this.projectType === '0'){
					this.$message.error('所有的内容必传哦')
					return
				}


				if(newArray.length < 6 && this.projectType === '3'){
					this.$message.error('所有的内容必传哦')
					return
				}

				if(newArray.length < 5 && this.projectType === '2'){
					this.$message.error('所有的内容必传哦')
					return
				}

				if(newArray.length < 6 && this.projectType === '1'){
					this.$message.error('所有的内容必传哦')
					return
				}


				if (this.projectType === '2') {
					if (!this.uploadList[1]) {
						this.$message.error('项目管理成果论文必传')
						return
					}
				}
				let dataJson = []
				this.uploadList.forEach((items, key) => {
					items.forEach((item, index) => {
						let data = {}
						data['data_name'] = item.name ? item.name : item.data_name
						data['type'] = key + 1
						data['stored_path'] = item.url ? item.url : item.stored_path
						dataJson.push(data)
					})
				})
				const params = {
					dataJson: dataJson,
					project_app_num: this.project_app_num
				}
				await getUploadFile({
					data: params,
					success: res => {
						// console.log(res)
						if (res.code === 200) {
							this.$message({
								message: res.msg + ',现在可以确认提交',
								type: 'success'
							});
							this.allSubmit = true
						} else {
							this.$message.error(res.msg)
						}
					}
				})
			},
			//接受点击上传回穿
			submitSuccess(e) {
				if (this.uploadList[this.clickIndex]) {
					let newList = [...this.uploadList[this.clickIndex], ...e]
					this.$set(this.uploadList, this.clickIndex, newList)
					return
				}
				this.$set(this.uploadList, this.clickIndex, e)
			},
			// 切换tab栏/
			changeTab(index) {
				//if(this.makeShow >1){

					this.navIndex = index

			//	}else{
				//	this.$message.error('还没完成阅读')
			//	}
			},
			// 获取必填警示
			requireSubmit(params, nameList) {
				//如果数据是对象形式
				let upString = []
				Object.keys(params).forEach((item, index) => {
					if (params[item] == '' || params[item] == undefined || params[item] == null) {
						if (nameList[item]) {
							upString.push(item)
						}
					}
				})
				if (!upString.length) {
					return false
				} else {
					this.$message.error(`${nameList[upString[0]]}未填写`)
					return true
				}
				// 如果数据是数组形式
			},

			// 获取项目明细
			async getProjectdetail(project_code) {
				await getProjectDetail({
					data: {
						project_code
					},
					success: (res) => {
						// console.log('获取项目明细', res.data)
						// 基本信息
						if (res.data.basicMsg) {

							this.makeShow = 2;

							this.basicMsg = res.data.basicMsg

							this.textarea = this.basicMsg.personal_resume
							this.textarea2 = this.basicMsg.personal_resume2

							if (this.basicMsg.participating_units) {
								this.oldAddList = JSON.parse(this.basicMsg.participating_units)
							}
							this.project_app_num = res.data.basicMsg.project_application_id

							// 获奖信息需要数据
							if (this.projectType === '0' || this.projectType === '1') {
								let number = 0
								this.levelTwo.awardJson = this.levelTwo.awardJson.map((item, index) => {
									item.project_app_num = this.project_app_num
									item.pa_award_type = number++
									return item
								})
							}
							if (this.projectType === '6') {
								let number = 0
								this.levelTwo.awardJson = this.levelTwo.awardJson.map((item,
																					   index) => {
									item.project_app_num = this.project_app_num
									item.pa_award_type = number++
									return item
								})
							}
							if (this.projectType === '3') {
								this.levelTwo.awardJson = this.levelTwo.awardJson.map((item,
																					   index) => {
									item.project_app_num = this.project_app_num
									// 先进企业
									if (index < 3) {
										item.pa_award_type = 0
									} else if (index > 2 && index < 6) {
										item.pa_award_type = 1
									} else if (index > 5 && index < 9) {
										item.pa_award_type = 2
									} else {
										item.pa_award_type = 3
									}
									return item
								})
							}
						}
						// 获奖信息
						if (res.data.award_list) {
							this.awardMsg = res.data.award_list
							// console.log('获取项目明细', res.data.award_list)
						}
						// 文件上传
						if (res.data.data_list) {
							const uploadList = res.data.data_list
							let newUploadList = []
							uploadList.forEach((item, index) => {
								newUploadList[Number(item.type) - 1] = []
							})
							uploadList.forEach((item, index) => {
								newUploadList[Number(item.type) - 1].push(item)
							})
							this.uploadList = newUploadList
						}

						this.basicParams = res.data
						// 申报通知PDF
						this.require_pdf_url = res.data.require_pdf_url
						// 评选标准PDF
						this.selection_pdf_url = res.data.selection_pdf_url
					}
				})
			},
			// 提交获奖信息
			async getWinninginfo() {
				const params = {
					awardJson: [...this.levelTwo.awardJson]
				}
				const newParams = params.awardJson
				if (!this.project_app_num) {
					this.$message.error('请先提交基本信息')
					return
				}
				if (this.projectType === '0' || this.projectType === '6') {
					// 优秀项目经理
					for (let key in newParams) {
						if (Object.keys(newParams[key]).length !== 5) {
							this.$message.error(this.award_msg[key] + '未填写完整')
							return
						}
					}
				} else if (this.projectType === '1') {
					// 优秀建造师
					for (let key in newParams) {
						if (key === '0') {
							// 5正常  3测试
							// 4正常  2测试
							// 5>3
							if (Object.keys(newParams[key]).length !== 5) {
								this.$message.error(this.award_msg[key] + '未填写完整')
								return
							}
						} else {
							const newarray = []
							for (let key in newParams) {
								if (key > 0) {
									// 0>2
									if (Object.keys(newParams[key]).length > 2) {
										this.check = true
										newarray.push(true)
									} else {
										newarray.push(false)
									}
								}
							}
							// 一个true都没有，就是都没填，有一个true就说明填了，未知是否填写完整
							if (newarray.indexOf(true) === -1) {
								this.check = false
							}
							if (!this.check) {
								this.$message.error('请至少选择一项进行填写')
								return
							}
							// 第一个数只能是5或者2，其他数不能为3
							// [[5,2,2],[5,4,2],[5,2,4],[5,4,4],[5,4,2],[2,4,2],[2,4,4],[2,2,4]]
							const newNun = []
							newParams.forEach((items, index) => {
								if (index > 0) {
									newNun.push(Object.keys(items).length)
								}
							})
							if ((newNun[0] === 5 || newNun[0] === 2) && (newNun[1] != 3) && (newNun[2] != 3)) {} else {
								if (key === '1') {
									// 如果填写了
									if (Object.keys(newParams[key]).length) {
										// console.log(Object.keys(newParams[key]).length)
										if (Object.keys(newParams[key]).length !== 5) {
											this.$message.error(this.award_msg[key] + '未填写完整')
											return
										}
									}
								} else {
									if (Object.keys(newParams[key]).length) {
										// console.log(Object.keys(newParams[key]).length)
										if (Object.keys(newParams[key]).length !== 4) {
											this.$message.error(this.award_msg[key] + '未填写完整')
											return
										}
									}
								}
							}
						}
					}
				} else if (this.projectType === '3') {
					// 先进企业
					// 当处于先进企业状态下，0-2是质量获奖情况、3-5安全文明情况、6-8科技、成果、9-11信用建设
					console.log(newParams)
					for (let key in newParams) {
						if (key < 6) {
							// 5正常  3测试
							// 4正常  2测试
							if (Object.keys(newParams[key]).length !== 5) {
								this.$message.error(this.award_msg[key] + '未填写完整')
								return
							}
						} else {
							if (Object.keys(newParams[key]).length !== 4) {
								this.$message.error(this.award_msg[key] + '未填写完整')
								return
							}
						}
					}
				}
				await getWinningInfo({
					data: params,
					success: (res) => {
						if (res.code === 200) {
							this.$message({
								message: res.msg,
								type: 'success'
							});
							// 自定义判断获奖信息 题没提交成功
						} else {
							this.$message.error(res.msg)
						}
					},
					fail: (err) => {
						console.log(err)
					}
				})
			},
			// 模板下载弹窗
			upShow(type, index) {
				this.clickIndex = index
				if (type === 'muban') {
					const params = {
						type,
						download: this.modelList
					}
					this.$refs['download'].showAdd(params)
				} else if (type === 'tips') {
					const params = {
						type,
						project_app_num: this.project_app_num
					}
					this.$refs['download'].showAdd(params)
				} else {

					sessionStorage.setItem('dataUpload',index);

					if (this.projectType === '2' && index === 1) {
						const params = {
							type,
							project: true,
						}
						this.$refs['download'].showAdd(params)
					} else {
						const params = {
							type,
							project_app_num: this.project_app_num
						}
						this.$refs['download'].showAdd(params)
					}
				}
			},

			// 基本信息申报
			async basicInfo() {
				const params = {
					...this.levelOne
				}
				if (this.project_app_num) {
					params.project_app_num = this.project_app_num
				}
				// 验证各个工程的表单
				if (this.requireSubmit(params, this.formName)) {
					return
				}
				// 验证优秀项目经理0/优秀建造师1
				if (this.projectType === '0' || this.projectType === '1') {
					// 验证优秀项目经理/优秀建造师 注册编号填没填
					if (!this.req_num_code) {
						this.$message.error('注册编号未填写')
						return
					}
					// 验证优秀项目经理/优秀建造师 注册编号文字部分部分
					if (!vaildte.isChina(this.levelOne.req_num)) {
						this.$message.error('注册编号首位请输入中文')
						return
					}
					// 验证优秀项目经理/优秀建造师 注册编号数字部分
					if (this.req_num_code.length === 12 || this.req_num_code.length === 16) {} else {
						this.$message.error('注册编号位数不满足条件')
						return
					}
					// 验证优秀项目经理/优秀建造师 注册编号全部内容
					params.req_num = params.req_num + this.req_num_code

					await getManagerInfo({
						data: params,
						success: (res) => {
							if (res.code === 200) {
								this.$message({
									message: res.msg,
									type: 'success'
								});
								this.project_app_num = res.data.project_app_num
								let number = 0
								this.levelTwo.awardJson = this.levelTwo.awardJson.map((item, index) => {
									item.project_app_num = this.project_app_num
									item.pa_award_type = number++
									return item
								})
							} else {
								if (res.data.project_app_num) {
									this.project_app_num = res.data.project_app_num
									let number = 0
									this.levelTwo.awardJson = this.levelTwo.awardJson.map((item,
																						   index) => {
										item.project_app_num = res.data.project_app_num
										item.pa_award_type = number++
										return item
									})
								}
								this.$message.error(res.msg)
							}
						},
					})
				}

				// 项目管理成果
				if (this.projectType === '2') {
					await getBasicA({
						data: params,
						success: res => {
							if (res.code === 200) {
								this.$message({
									message: res.msg,
									type: 'success'
								});
								this.project_app_num = res.data.project_app_num

							} else {
								this.project_app_num = res.data.project_app_num
								this.$message.error(res.msg)
							}
						}
					})
				}
				// 优质安装工程
				if (this.projectType === '5') {
					let newAddList = [...this.addList, ...this.oldAddList]
					for (let item in newAddList) {
						if (!newAddList[item].name || !newAddList[item].type) {
							this.$message.error('参建单位未填写完整')
							return
						}
					}
					// for (let item in this.addList) {
					// 	if (!this.addList[item].name || !this.addList[item].type) {
					// 		this.$message.error('参建单位未填写完整')
					// 		return
					// 	}
					// }
					params.participating_units = JSON.stringify(this.addList)
					await setBasicProgram({
						data: params,
						success: res => {
							if (res.code === 200) {
								this.$message({
									message: res.msg,
									type: 'success'
								});
								this.project_app_num = res.data.project_app_num
							} else {
								this.project_app_num = res.data.project_app_num
								this.$message.error(res.msg)
							}
						}
					})
				}
				// 质量小组
				if (this.projectType === '6') {
					await setTeamBasicInfo({
						data: params,
						success: res => {
							if (res.code === 200) {
								this.$message({
									message: res.msg,
									type: 'success'
								});
								this.project_app_num = res.data.project_app_num
								let number = 0
								this.levelTwo.awardJson = this.levelTwo.awardJson.map((item,
																					   index) => {
									item.project_app_num = res.data.project_app_num
									item.pa_award_type = number++
									return item
								})
							} else {
								if (res.data.project_app_num) {
									this.project_app_num = res.data.project_app_num
									let number = 0
									this.levelTwo.awardJson = this.levelTwo.awardJson.map((item,
																						   index) => {
										item.project_app_num = res.data.project_app_num
										item.pa_award_type = number++
										return item
									})
								}
								this.$message.error(res.msg)
							}
						}
					})
				}
				// 先进企业
				if (this.projectType === '3') {
					await setAdvanceInfo({
						data: params,
						success: res => {
							if (res.code === 200) {
								this.$message({
									message: res.msg,
									type: 'success'
								});
								this.project_app_num = res.data.project_app_num
								this.levelTwo.awardJson = this.levelTwo.awardJson.map((item,
																					   index) => {
									item.project_app_num = this.project_app_num
									// 先进企业
									if (index < 3) {
										item.pa_award_type = 0
									} else if (index > 2 && index < 6) {
										item.pa_award_type = 1
									} else if (index > 5 && index < 9) {
										item.pa_award_type = 2
									} else {
										item.pa_award_type = 3
									}
									return item
								})
							} else {
								if (res.data.project_app_num) {
									this.project_app_num = res.data.project_app_num
									let number = 0
									this.levelTwo.awardJson = this.levelTwo.awardJson.map((item,
																						   index) => {
										item.project_app_num = this.project_app_num
										// 先进企业
										if (index < 3) {
											item.pa_award_type = 0
										} else if (index > 2 && index < 6) {
											item.pa_award_type = 1
										} else if (index > 5 && index < 9) {
											item.pa_award_type = 2
										} else {
											item.pa_award_type = 3
										}
										return item
									})
									console.log(this.levelTwo.awardJson)
								}
								this.$message.error(res.msg)
							}
						}
					})
				}
				// BIM
				if (this.projectType === '7') {
					if (this.listArray.length) {
						for (let item in this.listArray) {
							if (Object.keys(this.listArray[item]).length !== 2) {
								this.$message.error('申报单位未填写完整')
								return
							}
						}
						params.declarant_units = JSON.stringify(this.listArray)
						await setBIMBasicInfo({
							data: params,
							success: res => {
								if (res.code === 200) {
									this.$message({
										message: res.msg,
										type: 'success'
									});
									this.project_app_num = res.data.project_app_num
								} else {
									this.project_app_num = res.data.project_app_num
									this.$message.error(res.msg)
								}
							}
						})
					} else {
						this.$message.error('申报单位未填写完整')
					}
				}

			},
			// 输入基本信息
			labelInput(e, name) {
				this.levelOne[name] = e
			},
			// 新增获奖信息
			labelInput3(e, name, id) {
				if (e) {
					this.levelTwo.awardJson[id][name] = e
				} else {
					delete this.levelTwo.awardJson[id][name]
				}

			}
		}
	}
</script>

<style scoped>
	/* 每个上传文件的样式 */
	.inner_upload {
		position: relative;
		min-height: 40px;
		margin: 0 10px;
		/* width: 100px; */
		/* overflow: scroll; */
	}

	.inner_upload p {
		color: #1890FF;
	}

	.inner_upload img {
		border-radius: 50%;
		position: absolute;
		right: 0;
		top: 0;
		width: 15px;
		height: 15px;
		cursor: pointer;
	}


	.headView_top_btn {
		position: relative;
		margin-right: 125px;
	}

	.btnTips {
		margin-top: 10px;
		display: flex;
		position: absolute;
		width: 350px;
		align-items: center;
	}

	.btnTips p {
		margin-left: 10px;
		font-size: 13px;
		color: #FE2c54;
	}

	/* 上传样式 */
	.uploadBtn {
		margin-top: 60px;
		margin-bottom: 60px;
		display: flex;
		margin-left: 41.5%;
	}

	.uploadBtn button {
		width: 140px;
	}

	.uploadHead {
		display: flex;
		position: absolute;
		align-items: center;
		left: 255px;
	}

	.uploadHead p {
		margin-left: 10px;
		color: #1890FF;
		cursor: pointer;
	}

	.uploadList {
		border: 1px solid #f0f0f0;
		width: 90%;
		margin-top: 30px;
		margin-left: 5%;
	}


	.uploadList_head {
		display: flex;
		align-items: center;
		justify-content: space-between;
		min-height: 40px;
		padding: 0 40px 0 10px;
		line-height: 40px;
		font-size: 14px;
		flex-wrap: wrap;
		border-bottom: 1px solid #f0f0f0;
	}

	.uploadList_head p {
		text-align: left;
	}

	.head_list {
		display: flex;
		align-items: center;
		cursor: pointer;
	}

	.head_list p {
		margin-left: 10px;
	}

	.head_list p:hover {
		color: #1890FF;
		text-decoration: underline;
	}

	.uploadList_mid {
		width: 90%;
		min-height: 30px;
		height: auto;
		display: flex;
		flex-wrap: wrap;
		align-content: space-around;
		justify-content: flex-start;
	}

	.uploadList_mid p {
		font-size: 12px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #666666;
		line-height: 24px;
		text-align: left;
		text-indent: 2em;
		padding: 10px;
	}

	.uploadList_bot {
		width: 70%;
		min-height: 30px;
		height: auto;
		display: flex;
		flex-wrap: wrap;
		align-content: space-around;
		justify-content: flex-start;
	}

	.uploadList_bot p {
		display: inline-block;
		height: 40px;
		line-height: 40px;
		color: #1890FF;
		text-decoration: underline;
		margin: 0 20px;
		cursor: pointer;
	}

	/* 上传样式 */
	.uploadContent {
		padding-bottom: 60px;
	}

	.inputList {
		display: flex;
		flex-wrap: wrap;
		margin-top: 20px;
	}

	.titleLeft {
		margin-left: 50px;
	}

	.view_head {
		font-size: 18px;
		font-weight: 600;
		margin-top: 20px;
	}

	.midflex {
		display: flex;
		width: 90%;
		height: 50px;
		margin-left: 5%;
		align-items: center;
		justify-content: center;
		border-top: 1px solid #eee;
	}

	.newAddBtn {
		width: 100%;
		display: flex;
		height: 70px;
		align-items: center;
		justify-content: center;
	}

	.headView {
		display: flex;
		flex-flow: column;
		align-items: flex-start;
	}

	.headView_top {
		width: 1350px;
		display: flex;
		justify-content: space-between;
	}

	.headView_top button {
		width: 100px;
		height: 35px;
		background-color: #1890FF;
		color: white;
		line-height: 35px;
		cursor: pointer;
	}

	.applyTitle {
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 600;
		color: #000000;
	}

	.applyTitle {
		font-size: 18px;
		font-family: PingFangSC-Medium, PingFang SC;
		font-weight: 600;
		color: #000000;
	}

	.headClass {
		display: flex;
		margin-top: 10px;
	}

	.headClass p {
		margin-right: 40px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #333333;
	}

	/* 申报 */
	.content_view {
		margin-top: 20px;
		max-width: 1350px;
		min-height: 350px;
		/* min-height: 750px; */
		display: flex;
		border: 1px solid #f0f0f0;
	}

	.contentLeft {
		width: 200px;
	}

	.contentLeft p {
		height: 50px;
		line-height: 50px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 500;
		color: #333333;
		background-color: #fafafa;
		cursor: pointer;
	}

	.contentRight {
		width: 100%;
	}

	.tabActive {
		background: #e6f7ff !important;
		color: #6ea7ff !important;
		border-right: 2px solid #0077ff;
	}

	.content_btn {
		display: flex;
		flex-flow: column;
		align-items: flex-start;
		margin-bottom: 30px;
	}

	.content_btn p {
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 400;
		color: #FE2C54;
	}

	.content_btn button {
		width: 150px;
		margin-top: 40px;
		margin-left: 440px;
	}

	.specialView {
		width: 720px;
		display: flex;
		align-items: center;
	}

	.specialView input {
		margin-left: 20px;
		width: 100%;
		height: 40px;
		line-height: 40px;
		font-size: 14px;
		font-family: PingFangSC-Regular, PingFang SC;
		font-weight: 500;
		letter-spacing: 1px;
		border-bottom: 1px solid #DBDBDB;
	}

	.specialView input::placeholder {
		color: #B5B5B5;
	}

	.dash_bottom {
		margin-top: 30px;
		margin-bottom: 20px;
		border-bottom: 1px solid #DBDBDB;
		margin-left: 120px;
		height: 1px;
		width: 81%;
	}
</style>
